import { Button } from '@/components/Button';
import { useGetCampaignQuery } from '@/models/campaign';
import { Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import { NavLink, useParams } from 'react-router';
import AddIcon from '@mui/icons-material/Add';
import { useGetCampaignAdsQuery } from '@/models/ad/query';
import { AdsTable } from '@/pages/campaign-details/AdsTable';

export const CampaignDetails = () => {
  const { id } = useParams();
  const { data: campaignData } = useGetCampaignQuery(
    { id: id || '' },
    {
      skip: !id,
    }
  );
  const { data: adsData = [], isLoading: isAdsLoading } =
    useGetCampaignAdsQuery(
      { campaignId: campaignData?.id || '' },
      {
        skip: !id,
      }
    );

  const {
    title,
    description,
    // heroImage,
    // gradientPlaceholder
  } = campaignData || {};

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-4">
        <Typography variant="h4" fontWeight={500}>
          {title}
        </Typography>
        <NavLink to="/client/create/ad">
          <Button variant="contained" color="secondary" startIcon={<AddIcon />}>
            <Trans i18nKey="ads.create_ad_text" />
          </Button>
        </NavLink>
      </div>
      <div>{description}</div>
      <div className="w-full mt-5 flex-1">
        <div className=" mt-7 mb-5">
          <AdsTable data={adsData} isLoading={isAdsLoading} />
        </div>
      </div>
    </div>
  );
};
